import { combineEpics } from "redux-observable";
import SearchContainerEpics from "../components/SearchContainer/SearchContainer.epics.js";
import SearchFiltersEpics from "../components/SearchFilters/SearchFilters.epics.js";
const rootEpic = combineEpics(SearchContainerEpics, SearchFiltersEpics);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
